import ApiService from '../api.services';

const LoadObjectService = {
  create: async function(data) {
    try {
      const response = await ApiService.post('/api/hangtags', data)
    } catch (error) {
      throw error;
    }
  },

  list: async function () {
      try {
          const response = await ApiService.get('/api/hangtags');
          return response.data;
      } catch (error) {
          throw error;
      }
  },

  get: async function (id) {
    try {
        const response = await ApiService.get(`/api/hangtags/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
  },

  refresh: async function (id) {
    try {
      const response = await ApiService.get(`/api/hangtags/refresh/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  download: async function (id) {
    try {
      const response = await ApiService.get(`/api/hangtags/download/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async function (id, formData) {
    try {
        const response = await ApiService.put(`/api/hangtags/${id}`, formData);
        return response.data;
    } catch (error) {
        throw error;
    }
  },

  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/hangtags/${id}`);
      return response.data;
    } catch (error) {
        throw error;
    }
  }
};

export default LoadObjectService;

export { LoadObjectService };

